import { createAction, props } from '@ngrx/store';

// Login Actions
export const login = createAction(
  '[Auth] Login',
  props<{ username: string; password: string; applicationId: string }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{
    token: string;
    userId: string;
    userEmail: string;
    userRoles: string[];
  }>()
);

export const hydrateAuthSuccess = createAction(
  '[Auth] Hydrate Auth Success',
  props<{
    token: string;
    userId: string;
    userEmail: string;
    userRoles: string[];
  }>(),
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: string }>()
);

// Logout Actions
export const logout = createAction('[Auth] Logout');

export const logoutSuccess = createAction('[Auth] Logout Success');

// Clear Error
export const clearError = createAction('[Auth] Clear Error');

// Load from Storage (on app init)
export const loadAuthFromStorage = createAction('[Auth] Load From Storage');

// Reset Password Actions
export const resetPassword = createAction(
  '[Auth] Reset Password',
  props<{ email: string }>()
);

export const resetPasswordSuccess = createAction('[Auth] Reset Password Success');

export const resetPasswordFailure = createAction(
  '[Auth] Reset Password Failure',
  props<{ error: string }>()
);

export const clearResetPasswordError = createAction('[Auth] Clear Reset Password Error');

export const clearResetPasswordSuccess = createAction('[Auth] Clear Reset Password Success');

export const hydrateAuth = createAction('[Auth] Hydrate Auth');

export const hydrateAuthFailure = createAction(
  '[Auth] Hydrate Auth Failure',
  props<{ error?: string }>()
);

export const resetLogin = createAction('[Auth] Reset Login');
